import ViewMap from './ViewMap.js';

class Context {

	constructor(options) {
		options = options || {};

		this.signals = options.signals;

		// Create the mappers
		this.views = new ViewMap(this);

		// Call the hook
		this.startup();
	}

	/**
	 * Hook for the extending context
	 */
	startup() {
	}

	/**
	 * @return {Context}
	 */
	start() {
		this.views.build();

		return this;
	}

	/**
	 * @return {Context}
	 */
	destroy() {
		this.views.destroy();

		return this;
	}

	/**
	 * @returns {String}
	 */
	toString() {
		return '[object Context]';
	}
}

export default Context;


// WEBPACK FOOTER //
// ./js/Core/Context.js